import React, { PropsWithChildren } from 'react';
import { Spin } from 'antd';

export const LoadingWrapper = ({
  children,
  loading = false,
}: PropsWithChildren<{ loading: boolean }>) => {
  if (loading) {
    return <Spin>{children}</Spin>;
  }

  return children;
};
